export default "__VITE_ASSET__Cl_X1ECv__"